export default __webpack_public_path__ + "static/media/eth_logo.98b4582a.svg";